import { render, staticRenderFns } from "./SearchApk.vue?vue&type=template&id=dc88a4c8&"
import script from "./SearchApk.vue?vue&type=script&lang=js&"
export * from "./SearchApk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports